import { render } from "./RevenueReport.vue?vue&type=template&id=4c5cf1ba&scoped=true"
import script from "./RevenueReport.vue?vue&type=script&lang=js"
export * from "./RevenueReport.vue?vue&type=script&lang=js"

import "./RevenueReport.vue?vue&type=style&index=0&id=4c5cf1ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5cf1ba"]])

export default __exports__